import React from "react";
import Header from "./Header";
import Navbar from "./Navbar";
import Footer from "./Footer";
import FloatingActions from "./FloatingActions";

const Layout = ({ children }) => (
  <div className="App font-sans bg-[#FBF8F1] text-[#20322E] antialiased min-h-screen flex flex-col">
    <div className="sticky top-0 z-40 bg-[#FBF8F1]">
      <Header />
      <Navbar />
    </div>
    <main className="flex-1">{children}</main>
    <Footer />
    <FloatingActions />
  </div>
);

export default Layout;
